/**
 * Normalise a DRF list response to a plain array.
 *
 * Several endpoints are annotated as paginated (`{ results: [...] }`) in the
 * generated schema but have pagination disabled on the backend and return a
 * bare array. Reading `.results` then yields `undefined`, so the caller renders
 * an empty state even though the API returned data. Accept either shape.
 *
 * Returns `[]` for a missing/unresolved response. When the caller must
 * distinguish "not loaded yet" from "loaded but empty", normalise manually
 * instead (see `AppAccessModal`).
 */
export const normalizeListResults = <T>(
  response: { results: T[] } | T[] | undefined | null
): T[] => {
  if (response == null) return []

  return Array.isArray(response) ? response : response.results
}
